import Abroad from './views/abroad.c';
export default Abroad;
